import React, { useState, useEffect } from "react";
import {
  AuthGet,
  AuthPost,
  AuthPut,
  AuthFile,
} from "../../common_var/httpService";
import toast from "react-hot-toast";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import { useFormik } from "formik";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import { useLocation, useNavigate } from "react-router-dom";
import updateIcon from "../../assets/images/updateIcon.svg";

const Fees = ({}) => {
  const navigate = useNavigate();
  const [countrycodes, setcountrycodes] = useState([false]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [data, setData] = useState([]);
  const [data3, setData3] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);

  useEffect(() => {
    getCurrency();
    get();
  }, []);

  const get = async () => {
    await AuthGet("nymcard/fees", "admin")
      .then((res) => {
        if (res?.statusCode === 200) console.log("rest", res);
        setData3(res?.data);
        // setcountrycodes()
        console.log("res", res);
      })
      .catch((err) => {
        console.log("hgdfhfdh");
      });
  };

  const getCurrency = async () => {
    await AuthGet(`nymcard/allowedcountries`, "admin")
      .then((res) => {
        setData(res.data);
        setcountrycodes();
        console.log("res", res.data);
      })
      .catch((err) => {
        console.log("hgdfhfdh");
      });
  };

  const columns = [
    {
      dataField: "",
      text: "S.NO",
      sort: true,
      formatter: (e, column, columnIndex, row, rowIndex) => {
        let total = currentPage * 5;
        total = total - 5;
        let slNo = total + columnIndex + 1;
        console.log("Total: ", total);
        return slNo;
      },
      headerStyle: {
        width: "50px",
      },
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
      classes: "ref_link",
      events: {
        // onClick: (e, column, columnIndex, row, rowIndex) => {
        //   navigate(`/admin/merchant/${row.id}`);
        // },
      },
      headerStyle: {
        width: "150px",
      },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: {
        width: "150px",
      },
    },
    {
      dataField: "type",
      text: "type",
      sort: true,
      headerStyle: {
        width: "250px",
      },
    },
    // {
    //     dataField: "", text: 'Edit', sort: true,
    //     formatter: () => {
    //         return <button className="btn deleteIcon">
    //             <img src={updateIcon} />
    //         </button>
    //     },
    //     events: {
    //         onClick: (e, column, columnIndex, row, rowIndex) => {
    //             console.log("MANAGE_DATA", row)
    //             // getEditPractice(row?.id);
    //         },
    //     },
    //     headerStyle: {
    //         width: '100px',
    //     }
    // },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
    {
      dataField: "descrption",
      order: "desc",
    },
    {
      dataField: "status",
      order: "desc",
    },
  ];

  const pagination = paginationFactory({
    page: page,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
      setCurrentPage(page);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });

  const { SearchBar, ClearSearchButton } = Search;

  //formik addsubmit
  const formik = useFormik({
    initialValues: {
      Description: "",
      type: "",
      currencycodes: "",
      Amount: 0,
      Percentage: 0,
      TransactionType: "",
    },
    validationSchema: Yup.object({
      Description: Yup.string().required("required"),
      type: Yup.string().required("required"),
      currencycodes: Yup.string().required("required"),
      Amount: Yup.number().required("required"),
      Percentage: Yup.number().required("required"),
      TransactionType: Yup.string().required("required"),
    }),
    onSubmit: async (values) => {
      values.role = parseInt(values.role);
      console.log(values);

      try {
        let post = await AuthPost("nymcard/fees", values, "admin");
        console.log("postssss", post);
        if (post.statusCode == 200) {
          toast.success("Fees added successfully");
          setShow(false);
        }
      } catch (error) {
        toast.error("Error");
        console.error("error", error);
      }
    },
  });

  return (
    <>
      <div className="whiteFrame">
        <div className="whiteFrameHeader displayFlex justifyConentEnd mb_12">
          <div>
            <button
              onClick={() => setShow(true)}
              className="mainPrimary_btn greenishTeal_Clr"
            >
              Add Balance Limit
            </button>
          </div>
        </div>
      </div>
      {/* Admin Add modal */}
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Fees</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mb_24">
              <label htmlFor="Description" className="labelText">
                Description
              </label>

              <input
                type="text"
                placeholder="Enter Description"
                className="adminInput"
                id="Description"
                name="Description"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.Description}
              />
              {formik.touched.Description && formik.errors.Description && (
                <p className="error_text">{formik.errors.Description}</p>
              )}
            </div>
            <div className="mb_24">
              <label htmlFor="type" className="labelText">
                Type
              </label>
               
              <select
                name="type"
                id="type"
                className="adminInput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="">select Type</option>
                <option value="FLAT">FLAT</option>

                <option value="PERCENTAGE">PERCENTAGE</option>
                <option value="MAX_PERC_OR_FLAT">MAX_PERC_OR_FLAT</option>
                <option value="MIN_PERC_OR_FLAT">MIN_PERC_OR_FLAT</option>
                <option value="MAX_PERC_OR_FLAT_W_CAP">
                  MAX_PERC_OR_FLAT_W_CAP
                </option>
                <option value="MIN_PERC_OR_FLAT_W_CAP">
                  MIN_PERC_OR_FLAT_W_CAP
                </option>
                <option value="RANGE">RANGE</option>
                <option value="RANGE_FLAT">RANGE_FLAT</option>
                <option value="RANGE_PERCENTAGE">FLAT</option>
                <option value="RANGE_MAX_PERC_OR_FLAT">FLAT</option>
                <option value="RANGE_MIN_PERC_OR_FLAT">FLAT</option>
                <option value="RANGE_MAX_PERC_OR_FLAT_W_CAP">FLAT</option>
                <option value="RANGE_MIN_PERC_OR_FLAT_W_CAP">FLAT</option>

                {/* <option </option> */}
              </select>
            </div>

            <div className="mb_24">
              <label htmlFor="type" className="labelText">
                currency codes
              </label>
               
              <select
                name="currencycodes"
                id="currencycodes"
                className="adminInput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.currencycodes}
              >
                {/* <option>Yes Or No</option>

                <option>Free Style</option> */}
                <option defaultValue value={null}>
                  Select currency
                </option>
                {data?.map((e, i) => {
                  console.log("e");
                  return (
                    <option key={i} value={e.value}>
                      {" "}
                      {e.currency_codes}{" "}
                    </option>
                  );
                })}
                {/* <option </option> */}
              </select>
            </div>
            <div className="mb_24">
              <label htmlFor="Description" className="labelText">
                Minimum amount
              </label>

              <input
                type="number"
                placeholder="Enter Minimum amount"
                className="adminInput"
                id="Minimunamount"
                name="Minimunamount"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.Minimunamount}
              />
              {formik.touched.Minimunamount && formik.errors.Minimunamount && (
                <p className="error_text">{formik.errors.Minimunamount}</p>
              )}
            </div>
            <div className="mb_24">
              <label htmlFor="Description" className="labelText">
                Amount
              </label>

              <input
                type="number"
                placeholder="Enter Maximum amount"
                className="adminInput"
                id="Maximumamount"
                name="Maximumamount"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.Maximumamount}
              />
              {formik.touched.Maximumamount && formik.errors.Maximumamount && (
                <p className="error_text">{formik.errors.Maximumamount}</p>
              )}
            </div>

            <div className="mb_24">
              <label htmlFor="type" className="labelText">
                Type
              </label>
               
              <select
                name="type"
                id="type"
                className="adminInput"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="">select Transaction Type</option>
                "WITHDRAWALS" "PURCHASES" "BALANCE_INQUIRIES" "TRANSFERS"
                "LOADS" "UNLOADS" "CURRENCY_MARKUP"
                <option value="WITHDRAWALS">WITHDRAWALS</option>
                <option value="PURCHASES">PURCHASES</option>
                <option value="BALANCE_INQUIRIES">BALANCE_INQUIRIES</option>
                <option value="TRANSFERS">TRANSFERS</option>
                <option value="LOADS">LOADS</option>
                <option value="UNLOADS">UNLOADS</option>
                <option value="CURRENCY_MARKUP">CURRENCY_MARKUP</option>
                {/* <option </option> */}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={handleClose}
              className="greenishTealClr_hover mainPrimary_btn"
              // disabled
            >
              Close
            </button>
            <button
              type="submit"
              className="mainPrimary_btn greenishTeal_Clr"
              disabled="disabled"
            >
              Save
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <div className="frameshadow">
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data3}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} />
              <ClearSearchButton {...props.searchProps} />
              <hr />
              <BootstrapTable
                bootstrap4
                key="loan_ref"
                defaultSorted={defaultSorted}
                pagination={pagination}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default Fees;
